import React, { FormEvent, useContext, useMemo } from 'react';
import { AppAgentContext } from 'src/context/ContextProvider';
import { AiAgent } from 'src/types/AiAgent';
import useIgnoreRenderEffect from '../../../hooks/useIgnoreRenderEffect';
import { initBot } from '../../../utils/botGenerator/htmlFormat';
import { chatbot, userImageSrc } from '../ai-agent-v2/AgentLayoutComponentV2';


export interface MessagesAgent {
    message: string,
    type: 'bot' | 'user',
    loading?: boolean,
    date?: Date;
}

interface Props {
    messages: MessagesAgent[],
    agent: AiAgent;
    onSubmit?: (e: FormEvent) => void;
    refContent?: React.RefObject<HTMLDivElement>;
    refInput?: React.RefObject<HTMLInputElement>;
    id: string;
}

// const messages = [
//   { message: 'Hola', type: 'user'},
//   { message: 'Hola, ¿en que puedo ayudarte?', type: 'bot'},
//   { message: '¿Puedes hablarme de los servicios de la web?', type: 'user'},
//   { message: 'Claro, Creamos soluciones de software sólidas, ágiles y adaptables a las necesidades de tu negocio', type: 'bot'},
//   { message: 'Gracias', type: 'user'},
//   { message: 'De nada, ¿Puedo ayudarte con algo más?', type: 'bot'},
// ];


export const AgentLayoutComponent = (props: Props) => {
    const { agent: setting } = props;
    const { state: { session: { domainName, origin } } } = useContext(AppAgentContext);

    const startOneRef = React.useRef<boolean>(false);

    const data = useMemo(() => {
        if (startOneRef.current) {
            startOneRef.current = false;
        }
        return setting;
    }, [setting]);

    const title = useMemo(() => {

        if (data) {
            if (data.agent_name.length > 0 && !data.title.length) {
                return data.agent_name;
            } else if (!data.agent_name.length && data.title.length > 0) {
                return data.title;
            } else if (data.agent_name.length > 0 && data.title.length > 0) {
                return data.title.replaceAll('[AgentName]', data.agent_name);
            } else {
                return 'Escribe tus preguntas';
            }
        }
    }, [setting]);


    const srcImage = useMemo(() => {
        if (data.avatar) {
            return data.avatar;
        } else return chatbot;
    }, [setting]);

    const config = {
        receiveIcon: srcImage,
        sendIcon: userImageSrc,
        title,
        placeholder: 'Type your message...',
        receiveMessage: data.agent_name,
        sendMessage: '',
        agentName: data.agent_name,
        backgroundReceive: data.background_agent_color ?? '#ffffff',
        backgroundSend: data.background_user_color ?? '#0486e4',
        colorReceive: data.text_agent_color ?? '#000000',
        colorSend: data.text_user_color ?? '#ffffff',
        background: '#fff',
        timeColor: '#aaaaaa',
        inputFocus: '#0486e4',
        backgroundChat: '#f3f3f3',
        colorBorderInputTop: '#e8e8e8',
        colorBorderInputBottom: '#e8e8e8',
        iconSendColor: data.button_color ?? '#0486e4',
        position: 'relative',
        suggestedMessage: data.getSuggestedMessage(),
    };

    const botRef = React.useRef<HTMLDivElement>(null);


    useIgnoreRenderEffect(() => {
        if (botRef.current && !startOneRef.current) {
            startOneRef.current = true;
            botRef.current?.querySelectorAll('script')?.forEach(item => item.remove());
            botRef.current?.querySelectorAll('#chat-bot-preview')?.forEach(item => item.remove());
            const session_id = `${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;


            initBot(props.id, data, config, botRef.current, origin.concat('/www/', domainName, '/ai-agent/'), session_id);
        }
    }, [data], 100);


    return (
        <div
            id={'agent-preview-id'}
            className="px-10 pt-6 min-[1800px]:scale-110"
            style={{ width: '400px', height: '600px', position: 'relative', overflow: 'hidden' }}
            ref={botRef}
        />
    );
};
